import { http } from '@/core/helpers/http.helper';
export class LogoService {
   async postLogo(tenantId: number, logo: any) {
      const formData = new FormData();
      formData.append('logo', logo);
      const response = await http.post(`/tenants/${tenantId}/logo`, formData);
      return response.data;
   }
}
